// Image sources the editor renders can come from the host over postMessage, so
// only schemes that load an image are let through: http(s), blob URLs from our
// own renders, and inline data images. Anything else (javascript:, vbscript:,
// data:text/html, …) becomes an empty src.
//
// The scheme is read with the URL parser rather than a pattern, so it is the
// scheme the browser will see: the parser drops tabs and newlines inside the
// URL and surrounding whitespace exactly as the <img> element does, which a
// pattern misses (`java\nscript:` is `javascript:` to the browser). A relative
// URL resolves against the editor's own origin, so it is allowed. An allowed
// src is returned unchanged.
const RELATIVE_BASE = 'https://editor.invalid/';

function getSafeImageSrc(src: string | undefined | null): string {
  if (!src) {
    return '';
  }

  let url: URL;
  try {
    url = new URL(src, RELATIVE_BASE);
  } catch {
    return '';
  }

  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'blob:':
      return src;
    case 'data:':
      return /^\s*image\//i.test(url.pathname) ? src : '';
    default:
      return '';
  }
}

export default getSafeImageSrc;
